// const enum EnvironmentTypes {
//   PRODUCTION = 'production',
//   STAGING = 'staging',
//   LOCAL = 'local',
//   DOCKER = 'docker',
// }
export const appVersion = process.env.PACKAGE_VERSION || '0';

// @todo @ramon can we make this nicer?
function matchStaging(): boolean {
  return !!window.location.hostname.match(/^(s2|staging)\./);
}
function matchLocal(): boolean {
  return !!window.location.hostname.match(/\.local$/);
}
export default {
  // isProduction: () => process.env.NODE_ENV === EnvironmentTypes.PRODUCTION,
  isProduction: () => !matchStaging() && !matchLocal(),
  // isStaging: () => process.env.NODE_ENV === EnvironmentTypes.STAGING,
  isStaging: () => matchStaging(),
  // isDocker: () => process.env.NODE_ENV === EnvironmentTypes.DOCKER,
  isLocal: () => matchLocal(),
};
